import { Button } from "../../../../core/components/Button";
import { Column } from "../../../../core/components/Column";
import { Input } from "../../../../core/components/Input";
import { useState, useEffect } from "react"; // Necesario para manejar los estados de error
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { WarningIcon } from "../../../../core/icons/Warning";
import { ArrowRightIcon } from "../../../../core/icons/ArrowRight";

export const DateTime: React.FC<{
	date: string;
	setDate: (value: string) => void;
	hour: string;
	setHour: (value: string) => void;
	next: () => void;
	back: () => void;
}> = ({ back, date, setDate, hour, setHour, next }) => {
	const [inputError, setInputError] = useState({
		date: false,
		hour: false,
	});

	useEffect(() => {
		if (date !== "") setInputError((prevState) => ({ ...prevState, date: false }));
		if (hour !== "") setInputError((prevState) => ({ ...prevState, hour: false }));
	}, [date, hour]);

	const handleNext = () => {
		if (date === "" || hour === "") {
			setInputError({
				date: date === "",
				hour: hour === "",
			});
			return;
		}
		next();
	};

	return (
		<>
			<Column className="gap-1 lg:gap-2">
				<Input
					id="date"
					label="Fecha del Sorteo"
					type="date"
					value={date}
					error={inputError.date}
					onChange={(e) => setDate(e.target.value)}
				/>
				{inputError.date && (
					<Row
						className="text-red-500 gap-0.5"
						crossAxisAlignment="center"
					>
						<WarningIcon className="w-3.5 h-3.5 lg:w-5 lg:h-5" />
						<TextComponent variant="h6">Este campo es obligatorio</TextComponent>
					</Row>
				)}
			</Column>
			<Column className="gap-1 lg:gap-2">
				<Input
					id="hour"
					label="Hora del Sorteo"
					type="time"
					value={hour}
					error={inputError.hour}
					onChange={(e) => setHour(e.target.value)}
				/>
				{inputError.hour && (
					<Row
						className="text-red-500 gap-0.5"
						crossAxisAlignment="center"
					>
						<WarningIcon className="w-3.5 h-3.5 lg:w-5 lg:h-5" />
						<TextComponent variant="h6">Este campo es obligatorio</TextComponent>
					</Row>
				)}
			</Column>
			<Column className="w-full gap-2">
				<Row
					className="gap-2 font-bold"
					flexible
					responsiveCol
				>
					<Button
						className="md:w-1/2"
						color="yellow"
						onClick={back}
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<ArrowRightIcon className="w-5 h-5 rotate-180" />
							<span>Atrás</span>
						</Row>
					</Button>
					<Button
						className="md:w-1/2 max-md:order-first"
						onClick={handleNext}
						color="orange"
						secondary
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<span>Siguiente</span>
							<ArrowRightIcon className="w-5 h-5" />
						</Row>
					</Button>
				</Row>
			</Column>
		</>
	);
};
